export default "__VITE_ASSET__D0FvO8Ci__"